import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/api.service';
import { ModalConstraintTreeComponent } from 'src/app/modals/database/modal-constraint-tree/modal-constraint-tree.component';

@Component({
  selector: 'database-contraints-tree',
  templateUrl: './database-contraints-tree.component.html',
  styleUrls: ['./database-contraints-tree.component.scss'],
})
export class DatabaseContraintsTreeComponent implements OnInit, OnDestroy {
  types: Array<any> = [];
  subTypes: Array<any> = [];
  descriptors: Array<any> = [];
  langSub?: Subscription;

  constructor(
    private api: ApiService,
    private router: Router,
    private translate: TranslateService,
    private modalService: MdbModalService
  ) {}

  ngOnInit(): void {
    this.getType();
    this.translate.onLangChange.subscribe(() => {
      this.getType();
    });
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  getType() {
    let databaseType: string = this.getCurrentLocation().toUpperCase();
    if (databaseType === 'CROP') databaseType = 'CROPS';
    if (databaseType === 'AQUACULTURE') databaseType = 'AQUATICS';

    this.api.getConstraints(databaseType).subscribe((value) => {
      this.types = value as Array<any>;
    });
  }

  getCurrentLocation() {
    const path = this.router.url;
    return path.split('/')[3];
  }

  getImage() {
    const base: string = '../../../assets/images/';
    const location: string = this.getCurrentLocation();
    const image = base + location + '.svg';
    return image;
  }

  onSelectType(i: number) {
    this.types.filter((value) => {
      value.selected = false;
    });
    this.subTypes.filter((value) => {
      value.selected = false;
    });
    this.descriptors.filter((value) => {
      value.selected = false;
    });
    this.types[i].selected = true;
    this.subTypes = this.types[i].subLevel;
    this.descriptors = [];
  }

  loadDescriptors = (i: number) => {
    if (this.subTypes[i].subLevel) {
      this.descriptors = [];
      this.descriptors = this.subTypes[i].subLevel;
    }
    this.subTypes.filter((value) => {
      value.selected = false;
    });
    this.descriptors.filter((value) => {
      value.selected = false;
    });
    this.subTypes[i].selected = true;
  };

  focusDescriptor(i: number) {
    this.descriptors.filter((value) => {
      value.selected = false;
    });
    this.descriptors[i].selected = true;
  }

  openConstraint(id: string, title: string) {
    this.modalService.open(ModalConstraintTreeComponent, {
      containerClass: 'bottom',
      modalClass: 'modal-frame modal-bottom',
      data: { constraitID: id, title: title },
    });
  }
}
